import { makeVar } from '@apollo/client';

import { getPersistedAccessToken } from '~LocalStorage/accessToken';

export const accessTokenReactiveVar = makeVar(getPersistedAccessToken());
